import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrivate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.83333 6.66602V5.66602C5.83333 4.26588 5.83333 3.56582 6.10582 3.03104C6.3455 2.56063 6.72795 2.17818 7.19836 1.9385C7.73313 1.66602 8.43317 1.66602 9.83333 1.66602H10.1667C11.5668 1.66602 12.2668 1.66602 12.8017 1.9385C13.2721 2.17818 13.6545 2.56063 13.8942 3.03104C14.1667 3.56582 14.1667 4.26588 14.1667 5.66602V6.66602M10 11.666V13.3327M7.83333 18.3327H12.1667C14.0335 18.3327 14.9669 18.3327 15.68 17.9693C16.3072 17.6498 16.8171 17.1398 17.1367 16.5127C17.5 15.7996 17.5 14.8662 17.5 12.9993V11.9993C17.5 10.1325 17.5 9.1991 17.1367 8.48602C16.8171 7.85884 16.3072 7.34891 15.68 7.02932C14.9669 6.66602 14.0335 6.66602 12.1667 6.66602H7.83333C5.96649 6.66602 5.03307 6.66602 4.32003 7.02932C3.69283 7.34891 3.18289 7.85884 2.86331 8.48602C2.5 9.1991 2.5 10.1325 2.5 11.9993V12.9993C2.5 14.8662 2.5 15.7996 2.86331 16.5127C3.18289 17.1398 3.69283 17.6498 4.32003 17.9693C5.03307 18.3327 5.96649 18.3327 7.83333 18.3327Z",
		stroke: "#EFEEF0",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgPrivate;
